<template>
  <div class="remove-contract">
    <div class="title">
      <i class="lf"></i>
      <p>注销当前账号</p>
      <i class="rf"></i>
    </div>
    <div class="notice">
      <img src="@/assets/images/person/remove-notice.png" />注销账号为不可恢复操作，注销账号后您将无法找回本账号，以及本账号相关的内容与信息；
    </div>
    <div class="content" v-html="detail"></div>
    <footer-btn>
      <p @click="$router.push({name:'RemoveSmscode'})" class="btns" slot="btn">我理解并同意，仍要注销</p>
    </footer-btn>
  </div>
</template>

<script>
export default {
  name: "RemoveContract",
  data() {
    return {
      detail: ""
    };
  },
  methods: {
    getDetail() {
      this.$http.get("/api/app/config/cancel_account_contract").then(res => {
        this.detail = res;
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.remove-contract {
  width: 100%;
  overflow: hidden;
  .title {
    display: flex;
    height: 90px;
    align-items: center;
    justify-content: center;
    i {
      width: 160px;
      height: 2px;
      border-radius: 1px;
      opacity: 0.49;
      &.lf {
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 1) 100%
        );
      }
      &.rf {
        background: linear-gradient(
          90deg,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      }
    }
    p {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      padding: 0 10px;
    }
  }
  .notice {
    width: 690px;
    height: 146px;
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(91, 96, 102, 1);
    line-height: 60px;
    margin: 0 auto;
    padding: 16px 30px;
    box-sizing: border-box;
    img {
      width: 26px;
      height: 24px;
      margin-right: 8px;
    }
  }
  .btns {
    margin: 10px auto 0;
    width: 690px;
    height: 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 37px;
    border: 2px solid rgba(65, 105, 255, 1);
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(65, 105, 255, 1);
    line-height: 74px;
    text-align: center;
  }
  .content {
    /deep/ img {
      width: 100%;
    }
  }
}
</style>
